import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const DiffLazyLoadedStates = new LazyLoadedStatesManager<{ 
    base: LazyLoadedStates,
    diffDashboard: LazyLoadedStates,
    diffDashboardView: LazyLoadedStates,
    diffDetails: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.user-summary.diff',
        url: '/diff',
        abstract: true
    },
    diffDashboard: {
        name: 'authenticated.user-summary.diff.dashboard',
        url: '/dashboard/:userId/:observationId',
        abstract: true,
    },
    diffDashboardView: {
        name: 'authenticated.user-summary.diff.dashboard.view',
        url: '/view',
    },
    diffDetails: {
        name: 'authenticated.user-summary.diff.details',
        url: '/details/:userId/:observationId/?:tabIndex',
    }
}, () => import('src/app/observations/differentiated/diff.module')
    .then((result: { DiffModule: any }) => result.DiffModule)
);
